/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * grimoire/v1/automation_phase.proto
 * OpenAPI spec version: version not set
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import * as axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

import type {
  AutomationPhaseServiceActivateTriggerBody,
  AutomationPhaseServiceDeactivateTriggerBody,
  AutomationPhaseServiceSetMarkedOutputsBody,
  AutomationPhaseServiceUnsetMarkedOutputBody,
  CreateAutomationTriggerParams,
  DeleteAutomationTriggerParams,
  ListAutomationTriggersParams,
  RpcStatus,
  V1ActivateTriggerResponse,
  V1AutomationTrigger,
  V1DeactivateTriggerResponse,
  V1DeleteAutomationTriggerResponse,
  V1GetPostAutomationPhaseRequest,
  V1ListAutomationTriggersResponse,
  V1PostAutomationPhase,
  V1SetMarkedOutputsResponse,
  V1UnsetMarkedOutputResponse,
  V1UpsertPostAutomationPhaseRequest,
  V1UpsertPostAutomationPhaseResponse,
} from '../models';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> =
  (<T>() => T extends X ? 1 : 2) extends <T>() => T extends Y ? 1 : 2 ? A : B;

type WritableKeys<T> = {
  [P in keyof T]-?: IfEquals<
    { [Q in P]: T[P] },
    { -readonly [Q in P]: T[P] },
    P
  >;
}[keyof T];

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (
  k: infer I,
) => void
  ? I
  : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>]
  ? {
      [P in keyof Writable<T>]: T[P] extends object
        ? NonReadonly<NonNullable<T[P]>>
        : T[P];
    }
  : DistributeReadOnlyOverUnions<T>;

/**
 * @summary ListAutomationTriggers retrieves all active triggers associated with an automation.
Returns a list of triggers that are currently active for the specified automation.
 */
export const listAutomationTriggers = (
  organization: string,
  workspace: string,
  automation: string,
  params?: ListAutomationTriggersParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListAutomationTriggersResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/triggers`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getListAutomationTriggersQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  params?: ListAutomationTriggersParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/triggers`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListAutomationTriggersQueryOptions = <
  TData = Awaited<ReturnType<typeof listAutomationTriggers>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: ListAutomationTriggersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAutomationTriggers>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListAutomationTriggersQueryKey(
      organization,
      workspace,
      automation,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAutomationTriggers>>
  > = ({ signal }) =>
    listAutomationTriggers(organization, workspace, automation, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listAutomationTriggers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListAutomationTriggersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAutomationTriggers>>
>;
export type ListAutomationTriggersQueryError = AxiosError<RpcStatus>;

export function useListAutomationTriggers<
  TData = Awaited<ReturnType<typeof listAutomationTriggers>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params: undefined | ListAutomationTriggersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAutomationTriggers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAutomationTriggers>>,
          TError,
          Awaited<ReturnType<typeof listAutomationTriggers>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListAutomationTriggers<
  TData = Awaited<ReturnType<typeof listAutomationTriggers>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: ListAutomationTriggersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAutomationTriggers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAutomationTriggers>>,
          TError,
          Awaited<ReturnType<typeof listAutomationTriggers>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListAutomationTriggers<
  TData = Awaited<ReturnType<typeof listAutomationTriggers>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: ListAutomationTriggersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAutomationTriggers>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary ListAutomationTriggers retrieves all active triggers associated with an automation.
Returns a list of triggers that are currently active for the specified automation.
 */

export function useListAutomationTriggers<
  TData = Awaited<ReturnType<typeof listAutomationTriggers>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: ListAutomationTriggersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAutomationTriggers>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListAutomationTriggersQueryOptions(
    organization,
    workspace,
    automation,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary CreateAutomationTrigger stores phase configuration metadata for an external trigger.
Returns the stored trigger configuration.
 */
export const createAutomationTrigger = (
  organization: string,
  workspace: string,
  automation: string,
  v1AutomationTrigger: NonReadonly<V1AutomationTrigger>,
  params?: CreateAutomationTriggerParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1AutomationTrigger>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/triggers`,
    v1AutomationTrigger,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getCreateAutomationTriggerMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAutomationTrigger>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: NonReadonly<V1AutomationTrigger>;
      params?: CreateAutomationTriggerParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAutomationTrigger>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: NonReadonly<V1AutomationTrigger>;
    params?: CreateAutomationTriggerParams;
  },
  TContext
> => {
  const mutationKey = ['createAutomationTrigger'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAutomationTrigger>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: NonReadonly<V1AutomationTrigger>;
      params?: CreateAutomationTriggerParams;
    }
  > = props => {
    const { organization, workspace, automation, data, params } = props ?? {};

    return createAutomationTrigger(
      organization,
      workspace,
      automation,
      data,
      params,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAutomationTriggerMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAutomationTrigger>>
>;
export type CreateAutomationTriggerMutationBody =
  NonReadonly<V1AutomationTrigger>;
export type CreateAutomationTriggerMutationError = AxiosError<RpcStatus>;

/**
 * @summary CreateAutomationTrigger stores phase configuration metadata for an external trigger.
Returns the stored trigger configuration.
 */
export const useCreateAutomationTrigger = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createAutomationTrigger>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        data: NonReadonly<V1AutomationTrigger>;
        params?: CreateAutomationTriggerParams;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createAutomationTrigger>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: NonReadonly<V1AutomationTrigger>;
    params?: CreateAutomationTriggerParams;
  },
  TContext
> => {
  const mutationOptions = getCreateAutomationTriggerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary DeleteAutomationTrigger removes a trigger from an automation and tears down
its external (BDK) trigger instance. The trigger must exist for the given
stage. Returns the trigger as it existed immediately before removal.
 */
export const deleteAutomationTrigger = (
  organization: string,
  workspace: string,
  automation: string,
  triggerId: string,
  params: DeleteAutomationTriggerParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1DeleteAutomationTriggerResponse>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/triggers/${triggerId}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getDeleteAutomationTriggerMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAutomationTrigger>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      triggerId: string;
      params: DeleteAutomationTriggerParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAutomationTrigger>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    triggerId: string;
    params: DeleteAutomationTriggerParams;
  },
  TContext
> => {
  const mutationKey = ['deleteAutomationTrigger'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAutomationTrigger>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      triggerId: string;
      params: DeleteAutomationTriggerParams;
    }
  > = props => {
    const { organization, workspace, automation, triggerId, params } =
      props ?? {};

    return deleteAutomationTrigger(
      organization,
      workspace,
      automation,
      triggerId,
      params,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAutomationTriggerMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAutomationTrigger>>
>;

export type DeleteAutomationTriggerMutationError = AxiosError<RpcStatus>;

/**
 * @summary DeleteAutomationTrigger removes a trigger from an automation and tears down
its external (BDK) trigger instance. The trigger must exist for the given
stage. Returns the trigger as it existed immediately before removal.
 */
export const useDeleteAutomationTrigger = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAutomationTrigger>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        triggerId: string;
        params: DeleteAutomationTriggerParams;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAutomationTrigger>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    triggerId: string;
    params: DeleteAutomationTriggerParams;
  },
  TContext
> => {
  const mutationOptions = getDeleteAutomationTriggerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary ActivateTrigger activates a trigger for an automation.
The trigger must exist and be in a deactivated state.
Returns the activated trigger configuration.
 */
export const activateTrigger = (
  organization: string,
  workspace: string,
  automation: string,
  triggerId: string,
  automationPhaseServiceActivateTriggerBody: AutomationPhaseServiceActivateTriggerBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ActivateTriggerResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/triggers/${triggerId}:activate`,
    automationPhaseServiceActivateTriggerBody,
    options,
  );
};

export const getActivateTriggerMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateTrigger>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      triggerId: string;
      data: AutomationPhaseServiceActivateTriggerBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof activateTrigger>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    triggerId: string;
    data: AutomationPhaseServiceActivateTriggerBody;
  },
  TContext
> => {
  const mutationKey = ['activateTrigger'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof activateTrigger>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      triggerId: string;
      data: AutomationPhaseServiceActivateTriggerBody;
    }
  > = props => {
    const { organization, workspace, automation, triggerId, data } =
      props ?? {};

    return activateTrigger(
      organization,
      workspace,
      automation,
      triggerId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ActivateTriggerMutationResult = NonNullable<
  Awaited<ReturnType<typeof activateTrigger>>
>;
export type ActivateTriggerMutationBody =
  AutomationPhaseServiceActivateTriggerBody;
export type ActivateTriggerMutationError = AxiosError<RpcStatus>;

/**
 * @summary ActivateTrigger activates a trigger for an automation.
The trigger must exist and be in a deactivated state.
Returns the activated trigger configuration.
 */
export const useActivateTrigger = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof activateTrigger>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        triggerId: string;
        data: AutomationPhaseServiceActivateTriggerBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof activateTrigger>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    triggerId: string;
    data: AutomationPhaseServiceActivateTriggerBody;
  },
  TContext
> => {
  const mutationOptions = getActivateTriggerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary DeactivateTrigger deactivates a trigger for an automation.
The trigger must exist and be in an activated state.
Returns the deactivated trigger configuration.
 */
export const deactivateTrigger = (
  organization: string,
  workspace: string,
  automation: string,
  triggerId: string,
  automationPhaseServiceDeactivateTriggerBody: AutomationPhaseServiceDeactivateTriggerBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1DeactivateTriggerResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/triggers/${triggerId}:deactivate`,
    automationPhaseServiceDeactivateTriggerBody,
    options,
  );
};

export const getDeactivateTriggerMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deactivateTrigger>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      triggerId: string;
      data: AutomationPhaseServiceDeactivateTriggerBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deactivateTrigger>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    triggerId: string;
    data: AutomationPhaseServiceDeactivateTriggerBody;
  },
  TContext
> => {
  const mutationKey = ['deactivateTrigger'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deactivateTrigger>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      triggerId: string;
      data: AutomationPhaseServiceDeactivateTriggerBody;
    }
  > = props => {
    const { organization, workspace, automation, triggerId, data } =
      props ?? {};

    return deactivateTrigger(
      organization,
      workspace,
      automation,
      triggerId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeactivateTriggerMutationResult = NonNullable<
  Awaited<ReturnType<typeof deactivateTrigger>>
>;
export type DeactivateTriggerMutationBody =
  AutomationPhaseServiceDeactivateTriggerBody;
export type DeactivateTriggerMutationError = AxiosError<RpcStatus>;

/**
 * @summary DeactivateTrigger deactivates a trigger for an automation.
The trigger must exist and be in an activated state.
Returns the deactivated trigger configuration.
 */
export const useDeactivateTrigger = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deactivateTrigger>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        triggerId: string;
        data: AutomationPhaseServiceDeactivateTriggerBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deactivateTrigger>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    triggerId: string;
    data: AutomationPhaseServiceDeactivateTriggerBody;
  },
  TContext
> => {
  const mutationOptions = getDeactivateTriggerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary SetMarkedOutputs sets a single marked output key for an automation.
 */
export const setMarkedOutputs = (
  organization: string,
  workspace: string,
  automation: string,
  automationPhaseServiceSetMarkedOutputsBody: AutomationPhaseServiceSetMarkedOutputsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1SetMarkedOutputsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}:setMarkedOutputs`,
    automationPhaseServiceSetMarkedOutputsBody,
    options,
  );
};

export const getSetMarkedOutputsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setMarkedOutputs>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationPhaseServiceSetMarkedOutputsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setMarkedOutputs>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationPhaseServiceSetMarkedOutputsBody;
  },
  TContext
> => {
  const mutationKey = ['setMarkedOutputs'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setMarkedOutputs>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationPhaseServiceSetMarkedOutputsBody;
    }
  > = props => {
    const { organization, workspace, automation, data } = props ?? {};

    return setMarkedOutputs(
      organization,
      workspace,
      automation,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type SetMarkedOutputsMutationResult = NonNullable<
  Awaited<ReturnType<typeof setMarkedOutputs>>
>;
export type SetMarkedOutputsMutationBody =
  AutomationPhaseServiceSetMarkedOutputsBody;
export type SetMarkedOutputsMutationError = AxiosError<RpcStatus>;

/**
 * @summary SetMarkedOutputs sets a single marked output key for an automation.
 */
export const useSetMarkedOutputs = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setMarkedOutputs>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        data: AutomationPhaseServiceSetMarkedOutputsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof setMarkedOutputs>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationPhaseServiceSetMarkedOutputsBody;
  },
  TContext
> => {
  const mutationOptions = getSetMarkedOutputsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary UnsetMarkedOutput removes a single marked output key from an automation.
 */
export const unsetMarkedOutput = (
  organization: string,
  workspace: string,
  automation: string,
  automationPhaseServiceUnsetMarkedOutputBody: AutomationPhaseServiceUnsetMarkedOutputBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1UnsetMarkedOutputResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}:unsetMarkedOutput`,
    automationPhaseServiceUnsetMarkedOutputBody,
    options,
  );
};

export const getUnsetMarkedOutputMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unsetMarkedOutput>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationPhaseServiceUnsetMarkedOutputBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unsetMarkedOutput>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationPhaseServiceUnsetMarkedOutputBody;
  },
  TContext
> => {
  const mutationKey = ['unsetMarkedOutput'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unsetMarkedOutput>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationPhaseServiceUnsetMarkedOutputBody;
    }
  > = props => {
    const { organization, workspace, automation, data } = props ?? {};

    return unsetMarkedOutput(
      organization,
      workspace,
      automation,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UnsetMarkedOutputMutationResult = NonNullable<
  Awaited<ReturnType<typeof unsetMarkedOutput>>
>;
export type UnsetMarkedOutputMutationBody =
  AutomationPhaseServiceUnsetMarkedOutputBody;
export type UnsetMarkedOutputMutationError = AxiosError<RpcStatus>;

/**
 * @summary UnsetMarkedOutput removes a single marked output key from an automation.
 */
export const useUnsetMarkedOutput = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof unsetMarkedOutput>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        data: AutomationPhaseServiceUnsetMarkedOutputBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof unsetMarkedOutput>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationPhaseServiceUnsetMarkedOutputBody;
  },
  TContext
> => {
  const mutationOptions = getUnsetMarkedOutputMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary GetPostAutomationPhase retrieves the post automation phase for a specific automation version.
Returns the post phase configuration including code and connections for the requested version.
If version is not specified, returns the post phase for the latest published version.
 */
export const getPostAutomationPhase = (
  v1GetPostAutomationPhaseRequest: V1GetPostAutomationPhaseRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1PostAutomationPhase>> => {
  return axios.default.post(
    `/grimoire.v1.AutomationPhaseService/GetPostAutomationPhase`,
    v1GetPostAutomationPhaseRequest,
    options,
  );
};

export const getGetPostAutomationPhaseMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getPostAutomationPhase>>,
    TError,
    { data: V1GetPostAutomationPhaseRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getPostAutomationPhase>>,
  TError,
  { data: V1GetPostAutomationPhaseRequest },
  TContext
> => {
  const mutationKey = ['getPostAutomationPhase'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getPostAutomationPhase>>,
    { data: V1GetPostAutomationPhaseRequest }
  > = props => {
    const { data } = props ?? {};

    return getPostAutomationPhase(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetPostAutomationPhaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof getPostAutomationPhase>>
>;
export type GetPostAutomationPhaseMutationBody =
  V1GetPostAutomationPhaseRequest;
export type GetPostAutomationPhaseMutationError = AxiosError<RpcStatus>;

/**
 * @summary GetPostAutomationPhase retrieves the post automation phase for a specific automation version.
Returns the post phase configuration including code and connections for the requested version.
If version is not specified, returns the post phase for the latest published version.
 */
export const useGetPostAutomationPhase = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getPostAutomationPhase>>,
      TError,
      { data: V1GetPostAutomationPhaseRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getPostAutomationPhase>>,
  TError,
  { data: V1GetPostAutomationPhaseRequest },
  TContext
> => {
  const mutationOptions = getGetPostAutomationPhaseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary UpsertPostAutomationPhase creates or updates the post automation phase for an automation.
Creates the phase if it doesn't exist, or updates it if it does (upsert semantics).
The resource is identified by the name field in post_automation_phase.
 */
export const upsertPostAutomationPhase = (
  v1UpsertPostAutomationPhaseRequest: V1UpsertPostAutomationPhaseRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1UpsertPostAutomationPhaseResponse>> => {
  return axios.default.post(
    `/grimoire.v1.AutomationPhaseService/UpsertPostAutomationPhase`,
    v1UpsertPostAutomationPhaseRequest,
    options,
  );
};

export const getUpsertPostAutomationPhaseMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertPostAutomationPhase>>,
    TError,
    { data: V1UpsertPostAutomationPhaseRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upsertPostAutomationPhase>>,
  TError,
  { data: V1UpsertPostAutomationPhaseRequest },
  TContext
> => {
  const mutationKey = ['upsertPostAutomationPhase'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upsertPostAutomationPhase>>,
    { data: V1UpsertPostAutomationPhaseRequest }
  > = props => {
    const { data } = props ?? {};

    return upsertPostAutomationPhase(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpsertPostAutomationPhaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof upsertPostAutomationPhase>>
>;
export type UpsertPostAutomationPhaseMutationBody =
  V1UpsertPostAutomationPhaseRequest;
export type UpsertPostAutomationPhaseMutationError = AxiosError<RpcStatus>;

/**
 * @summary UpsertPostAutomationPhase creates or updates the post automation phase for an automation.
Creates the phase if it doesn't exist, or updates it if it does (upsert semantics).
The resource is identified by the name field in post_automation_phase.
 */
export const useUpsertPostAutomationPhase = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof upsertPostAutomationPhase>>,
      TError,
      { data: V1UpsertPostAutomationPhaseRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof upsertPostAutomationPhase>>,
  TError,
  { data: V1UpsertPostAutomationPhaseRequest },
  TContext
> => {
  const mutationOptions = getUpsertPostAutomationPhaseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
